import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { leaveForLoginRedirect, readLoginRedirect } from "../auth/login_redirect";

/**
 * Where a completed sign-in goes: back to the allowed app that sent the user here, or the
 * project list. The return URL is read from the current page's query string.
 */
export const useLoginRedirect = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const redirect = readLoginRedirect(search);

  const completeLogin = useCallback(() => {
    if (redirect) return leaveForLoginRedirect(redirect);
    navigate("/project");
  }, [redirect, navigate]);

  return { redirect, completeLogin };
};
